export const shouldResetChatForNewSession = (previousSessionId: string | null | undefined, nextSessionId: string | null | undefined): boolean =>
  Boolean(nextSessionId && previousSessionId && nextSessionId !== previousSessionId)

export const chatResetOnNewSession = () => ({
  messages: [] as [],
  isChatEnded: false,
  liveSupportState: null,
  operatorName: null,
  selectedSection: null,
  isShowSectionSelectButtons: true,
  isTakenOver: false
})
